module.exports = __webpack_public_path__ + "img/spot.11dc3653.jpeg";